import { UserRole } from "@/types/user"

export enum MessageType {
   TEXT = "text",
   EMAIL = "email",
}

export interface Contact {
   id: string
   name: string
   email: string
   phone: string
   role: UserRole
}

export const mockContactsList: Contact[] = [
   {
      id: "contact-1",
      name: "John Johnson",
      email: "john@johnson.com",
      phone: "270654321",
      role: UserRole.GUARD,
   },
   {
      id: "contact-2",
      name: "John Sue",
      email: "john@sue.com",
      phone: "270987654",
      role: UserRole.GUARD,
   },
   {
      id: "contact-3",
      name: "Johnny Bravo",
      email: "johnny@bravo.com",
      phone: "270123456",
      role: UserRole.GUARD,
   },
   {
      id: "contact-4",
      name: "Mary Sue",
      email: "mary@sue.com",
      phone: "270111222",
      role: UserRole.GUARD,
   },
]

export const getRecipientNames = (
   recipients: string[],
   contacts: Contact[]
): string[] =>
   recipients.map(
      (id) => contacts.find((contact) => contact.id === id)?.name ?? id
   )
